var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.04 12.94-.746 2.781-2.724.058a10.658 10.658 0 0 1-1.276-5.073c0-1.776.432-3.45 1.197-4.924l2.426.445 1.062 2.41a6.364 6.364 0 0 0-.343 2.069c0 .786.142 1.538.403 2.233Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.518 8.706a10.726 10.726 0 0 1-.047 4.235 10.703 10.703 0 0 1-3.77 6.114v-.001l-3.055-.156-.432-2.699a6.38 6.38 0 0 0 2.745-3.258h-5.724V8.706h10.283Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.702 19.053v.001A10.66 10.66 0 0 1 11 21.411a10.704 10.704 0 0 1-9.43-5.632l3.47-2.84a6.365 6.365 0 0 0 9.175 3.26l3.487 2.854Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.833 2.465-3.468 2.839a6.367 6.367 0 0 0-9.386 3.333L1.492 5.782A10.704 10.704 0 0 1 11 0c2.597 0 4.98.925 6.833 2.465Z",
    fill: "#F14336"
  })));
};
export default SvgGoogle;